var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-button",class:_vm.activeClass,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onClick($event)}}},[_c('div',{staticClass:"bars"})])}
var staticRenderFns = []

export { render, staticRenderFns }